// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ShareMarketingProfileDialog = require("./ShareMarketingProfileDialog.bs.js");
let ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql = require("../../__generated__/ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.bs.js");

let convertFragment = ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ShareAgentMarketingProfileDialog(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment, props.marketingProfile);
  return JsxRuntime.jsx(ShareMarketingProfileDialog.make, {
    publicUrl: marketingProfile.publicUrl,
    urlDetails: Primitive_option.some(marketingProfile.urlDetails.fragmentRefs),
    isOpen: props.isOpen,
    onDismiss: props.onDismiss
  });
}

let make = ShareAgentMarketingProfileDialog;

exports.Fragment = Fragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
